<template>
    <div>
        <v-tabs
            :model-value="tab"
            class="mt-3 mx-n2 c-transparent-tabs px-10 position-relative"
            center-active
            @update:model-value="emit('update:modelValue', $event)"
        >
            <v-tab
                v-for="(tab, index) in tabs"
                :value="index"
                :key="index"
                :append-icon="mdiChevronDown"
                color="warning"
                class="px-2 text-decoration-underline font-weight-normal text-body-1 text-grey-darken-1 font-weight-regular"
            >
                {{ tab.name }}
            </v-tab>
            <v-btn
                href="#recommended"
                variant="text"
                v-if="alsoLike.length"
                :append-icon="mdiChevronDown"
                class="v-tab px-2 text-decoration-underline font-weight-normal text-body-1 text-grey-darken-1 font-weight-regular"
            >
                {{$t('eshop::product-details.related_products')}}
            </v-btn>
            <v-btn
                href="#alternative"
                variant="text"
                v-if="product.alternatives.length"
                :append-icon="mdiChevronDown"
                class="v-tab px-2 text-decoration-underline font-weight-normal text-body-1 text-grey-darken-1 font-weight-regular"
            >
                {{$t('eshop::product-details.alternative_products')}}
            </v-btn>
        </v-tabs>
        <v-sheet>
            <v-row no-gutters>
                <v-col lg="8" cols="12">
                    <v-card-text class="pa-0 h-100">
                        <v-window :model-value="tab" class="h-100">
                            <v-window-item v-for="(tab, index) in tabs"
                                           :value="index"
                                           :key="index"
                                           class="py-10 pl-0 pr-10 h-100"
                                           :class="tab.class"
                            >
                                <motonet-header>
                                    <div class="text-h4 font-weight-black">
                                        {{ tab.title || tab.name }}
                                    </div>
                                </motonet-header>
                                <div class="pl-10" :class="{'mt-10': !tab.noTopMargin}">
                                    <template v-if="'content' in tab">
                                        <div v-html="tab.content"/>
                                    </template>
                                    <template v-else-if="'component' in tab">
                                        <component :is="tab.component" v-bind="tab.props"></component>
                                    </template>
                                    <template v-else>
                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, culpa, id. Ab
                                        animi,
                                        blanditiis doloremque eius esse eveniet excepturi expedita explicabo
                                        incidunt
                                        laborum
                                        magnam
                                        nostrum odit porro quisquam vitae voluptas!
                                    </template>
                                </div>
                            </v-window-item>
                        </v-window>
                    </v-card-text>
                </v-col>
                <v-col v-if="$vuetify.display.lgAndUp" lg="4" class="d-flex pr-10">
                    <v-divider vertical class="h-100 mr-3"></v-divider>
                    <need-help :email="customerEmail" class="py-10"></need-help>
                </v-col>
            </v-row>
        </v-sheet>
    </div>
</template>

<script setup>
import {mdiChevronDown} from "@mdi/js";
import NeedHelp from "./NeedHelp.vue";
import MotonetHeader from "./MotonetHeader.vue";
import { computed, ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';

defineProps({
    tab: [Number, String],
    product: Object,
    tabs: Array,
    alsoLike: Array,
})

const customerEmail = ref(usePage().props?.customer?.email);

const user = computed(() => usePage().props.customer)
watch(user, (val) => {
    customerEmail.value = val.email;
}, { immediate: true });


const emit = defineEmits(['update:modelValue'])
</script>

<style scoped lang="scss">

</style>
